import * as types from "../types";
import { requestAuth, axiosAuth } from "../../helpers/FetchApi";
import appSettings from "../../AppSettings";
import { history } from "../../src/history";
import { toast } from "react-toastify";
import strings from "../../helpers/Localization";
import axios from "axios";

export const actionCreators = {

    GetUsersList: (pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess, secondary) => async (dispatch, store) => {
        secondary ? dispatch({ type: types.GET_USERS_SECONDARY_COMPLETED, payload: null }) : dispatch({ type: types.GET_USERS_COMPLETED, payload: null });
        if (pageSize < 0) {return onSuccess(null);}

        const orgId = store().currentuser.currentorganization.id;

        const apiName = "OrganizationUsers";

        await requestAuth(appSettings.SKALINKAPIURL + "/api/Users/" + apiName + "/" + orgId + "?"
                + "pageNumber=" + pageNumber
                + "&pageSize=" + pageSize
                + (sortExpression ? "&sortExpression=" + sortExpression : "")
                + (filterExpression ? "&filterExpression=" + filterExpression : "")
        , {
            method: "GET"
        }).then((data) => {
            data.sortExpression = sortExpression;
            data.filterExpression = filterExpression;
            data.tagSearchRequest = tagSearchRequest;
            data.PaginationType = PaginationType;
            data.results = data.results ? data.results : [];
            secondary ? dispatch({ type: types.GET_USERS_SECONDARY_COMPLETED, payload: data }) : dispatch({ type: types.GET_USERS_COMPLETED, payload: data });
            return onSuccess(data);
        }).catch( (data) => {
            console.log(data);
        });
    },
    SaveUsersPagination: (paginationType) => (dispatch, store) => {
        const data = store().administration.users;
        dispatch({ type: types.GET_USERS_COMPLETED, payload: { ...data, PaginationType: paginationType } });
    },

    GetSecondaryUsersList: (onSuccess) => async (dispatch, store) => {
        dispatch({ type: types.GET_USERS_SECONDARY_COMPLETED, payload: null });
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Users/AllOrganizationUsers/" + store().currentuser.currentorganization.id,
            {
                method: "GET"
            }).then((data) => {
            dispatch({ type: types.GET_USERS_SECONDARY_COMPLETED, payload: { results: data } });
            return onSuccess({ results: data });
        }).catch( (data) => {
            console.log(data);
        });
    },

    ForceLogout: (userId, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Users/ForceLogout/" + store().currentuser.currentorganization.id + "/" + userId,
            {
                method: "GET"
            }).then((data) => {
            return onSuccess(data);
        }).catch( (data) => {
            console.log(data);
        });
    },

    GetUser: (id, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Users/" + store().currentuser.currentorganization.id + "/" + id, {
            method: "GET"
        }).then((data) => {
            return onSuccess(data);
        }).catch( (data) => {
            console.log(data);
        });
    },

    EditOrganizationUser: (organizationUsers, onSuccess, filesList) => (dispatch, store) => {

        const formData = new FormData();
        if (filesList) {
            filesList.forEach(file => {
                formData.append("files", file);
            });
        }
        formData.append("contentObjAsString", JSON.stringify(organizationUsers));



        axiosAuth(
            `${appSettings.SKALINKAPIURL}/api/OrganizationUsers/${organizationUsers.organizationId}/${organizationUsers.userId}`,
            {
                method: "PUT",
                data: formData,
                headers: {
                    "Content-Type": "application/json"
                },
                onUploadProgress: (progressEvent) => {
                    //const progress = parseInt(Math.round(progressEvent.loaded * 100 / progressEvent.total));
                }
            }
        )
            .then(function (data) {
                //update currentuser
                if (store().currentuser.user.id === organizationUsers.userId) {
                    const user = store().currentuser.user;
                    user.organizationUsers.forEach(element => {
                        if (element.organizationId === organizationUsers.organizationId) {
                            element = organizationUsers;
                        }
                    });
                    dispatch({ type: types.GET_CURRENTUSER_COMPLETED, assets: user });

                    //if current organization and isDisabled:true -> go Login
                    if (store().currentuser.currentorganization.id === organizationUsers.organizationId && organizationUsers.isDisabled ) {
                        // dispatch(push("/Login"));
                        history.push("/Login");

                    }

                    onSuccess(data);
                }
                else {
                    onSuccess(data);
                }
            })
            .catch(function (error) {
                console.log("error", error);
            });
    },

    RemoveOrganizationUser: (organizationId, userId, onSuccess) => async (dispatch, store) => {

        await requestAuth(appSettings.SKALINKAPIURL + "/api/OrganizationUsers/" + organizationId + "/" + userId, {
            headers: {
                "Content-Type": "application/json"
            },
            method: "DELETE"
        }).then((data) => {
            toast.success(strings.orgUserRemoved);
            onSuccess(data);
        }).catch( (data) => {
            console.log("error", data);
        });
    },

    GetCallCenterById: (onSuccess, callCenterId) => async (store, getState) => {
        try {
            return await requestAuth(`${appSettings.SKALINKAPIURL}/api/CallCenters/${callCenterId}`, {
                method: "GET"
            })
                .then((data) => {
                    if (onSuccess) {
                        onSuccess({ results: data });
                    }
                    return data;
                })
                .catch((err) => {
                    console.error("GetCallCenterById error request", err);
                    throw err;
                });

        }
        catch (err) {
            console.error("GetCallCenterById error thunk", err);
            throw err;
        }
    }

};
